import { graphql } from '~/apollo/generated/v3';

export const DEPOSITIONAL_HIERARCHY = graphql(`
  query DepositionalHierarchy {
    depositionalHierarchyFull {
      clastic {
        grossDepositionalEnvironment {
          name
          depositionalEnvironment {
            name
            depositionalSubEnvironment {
              name
              architecturalElement {
                name
              }
            }
          }
        }
      }

      carbonate {
        grossDepositionalEnvironment {
          name
          depositionalEnvironment {
            name
            depositionalSubEnvironment {
              name
              architecturalElement {
                name
              }
            }
          }
        }
      }

      structural {
        grossDepositionalEnvironment {
          name
          depositionalEnvironment {
            name
            depositionalSubEnvironment {
              name
              architecturalElement {
                name
              }
            }
          }
        }
      }
    }
  }
`);
